import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private baseUrl = `${environment.cmiApiUri}`;

  constructor(private httpClient: HttpClient) {}

  isUserSubscribed(email: string): Observable<boolean> {
    const url = `${this.baseUrl}/api/emailsubscription/isUserSubscribed?email=${email.trim()}`;
    return this.httpClient.get<boolean>(url);
  }

  toggleUserSubscription(email: string): Observable<boolean> {
    const url = `${this.baseUrl}/api/emailsubscription/toggleUserSubscription`;
    return this.httpClient.post<boolean>(url, { email: email.trim() });
  }
}
